module.exports = "/video-roulette/img/fast-arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/fast-arrow-right.png
// module id = 2434
// module chunks = 10